import { render, staticRenderFns } from "./PageBreadcrumbItem.vue?vue&type=template&id=6b6a8dc6&scoped=true"
import script from "./PageBreadcrumbItem.js?vue&type=script&lang=js&external"
export * from "./PageBreadcrumbItem.js?vue&type=script&lang=js&external"
import style0 from "./PageBreadcrumbItem.scss?vue&type=style&index=0&id=6b6a8dc6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a8dc6",
  null
  
)

export default component.exports